var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0999 12.6089V13.6479H23.9399V12.6089C23.9395 12.402 23.98 12.197 24.059 12.0057C24.138 11.8145 24.254 11.6407 24.4004 11.4944C24.5467 11.348 24.7205 11.232 24.9118 11.153C25.103 11.074 25.308 11.0335 25.5149 11.0339H32.5289C32.7355 11.0342 32.94 11.0751 33.1308 11.1544C33.3215 11.2337 33.4948 11.3498 33.6406 11.4961C33.7865 11.6423 33.9022 11.8159 33.981 12.0068C34.0598 12.1978 34.1002 12.4024 34.0999 12.6089Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.06 12.6089V13.6479H7.90003V12.6089C7.89976 12.402 7.94032 12.1971 8.01938 12.0059C8.09844 11.8147 8.21444 11.641 8.36075 11.4947C8.50705 11.3484 8.68078 11.2323 8.87199 11.1533C9.06319 11.0742 9.26812 11.0337 9.47503 11.0339H16.489C16.6956 11.0341 16.9002 11.0749 17.091 11.1542C17.2818 11.2334 17.4551 11.3495 17.601 11.4958C17.7469 11.6421 17.8626 11.8157 17.9413 12.0067C18.0201 12.1977 18.0604 12.4023 18.06 12.6089Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 4.198V13.698C39.2012 13.6703 39.0259 13.6529 38.85 13.646H36.2V12.609C36.1989 11.6347 35.8114 10.7005 35.1224 10.0116C34.4335 9.32258 33.4993 8.93506 32.525 8.934H25.515C24.5406 8.93479 23.6063 9.32224 22.9173 10.0113C22.2282 10.7003 21.8408 11.6346 21.84 12.609V13.648H20.16V12.609C20.1592 11.6346 19.7718 10.7003 19.0827 10.0113C18.3937 9.32224 17.4594 8.93479 16.485 8.934H9.471C8.49735 8.93612 7.56424 9.32411 6.87614 10.013C6.18803 10.7018 5.80106 11.6353 5.8 12.609V13.648H3.15C2.97412 13.6549 2.79882 13.6723 2.625 13.7V4.2C2.625 3.08609 3.0675 2.0178 3.85515 1.23015C4.6428 0.442497 5.71109 0 6.825 0H35.175C36.2886 -1.26254e-07 37.3565 0.442222 38.1441 1.22944C38.9317 2.01666 39.3745 3.08444 39.375 4.198Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9501 17.848V22.048H1.05005V17.848C1.05163 17.2916 1.27339 16.7584 1.66687 16.3649C2.06036 15.9714 2.59358 15.7496 3.15005 15.748H38.85C39.4065 15.7496 39.9397 15.9714 40.3332 16.3649C40.7267 16.7584 40.9485 17.2916 40.9501 17.848Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 24.1479H0V28.3479H42V24.1479Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25002 30.448H3.15002V31.498H5.25002V30.448Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.85 30.448H36.75V31.498H38.85V30.448Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.486ba4eb9b3dccc468a84ea265a542e7.svg";
export { ForwardRef as ReactComponent };